// Returns { token, role } or { requireTotp, tempToken } or throws on bad password
export const login = async (password) => {
  const res = await fetch('/api/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });
  if (!res.ok) throw new Error('Invalid password');
  return res.json(); // { token, role } или { requireTotp: true, tempToken }
};

// Второй шаг — проверка TOTP-кода
export const verifyTotp = async (tempToken, code) => {
  const res = await fetch('/api/auth/verify-totp', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${tempToken}` },
    body: JSON.stringify({ code }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Неверный код');
  }
  return res.json(); // { token, role }
};

export const getToken = () => sessionStorage.getItem('auth_token');
export const getRole  = () => sessionStorage.getItem('auth_role');

export const saveSession = ({ token, role }) => {
  sessionStorage.setItem('auth_token', token);
  sessionStorage.setItem('auth_role', role);
};

export const clearSession = () => {
  sessionStorage.removeItem('auth_token');
  sessionStorage.removeItem('auth_role');
};

export const isLoggedIn = () => !!getToken();

// Attach Authorization header to all mutating API calls
export const authHeaders = () => ({
  'Authorization': `Bearer ${getToken()}`,
  'Content-Type': 'application/json',
});
